/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/naming-convention */

import * as $ from 'jquery';
import { toLonLat, transformExtent } from 'ol/proj';
import { unzip } from 'unzipit';
declare var Windy: any;
var wind: any, deg: any, speed: any, direction: any;
var windy: any;
var canvas: any;
var map: any;

export function Wind(
  this: any,
  options1: any,
  layerType: any,
  property: any = 'none'
): any {
  const workspace = layerType.values_.mapport.map.name.split(':');
  const server =
    layerType.values_.mapport.map.name.indexOf(':') === -1
      ? layerType.values_.mapport.map.server
      : layerType.values_.mapport.map.server.replace(
          'wms',
          workspace[0] + '/wms'
        );

  map = options1.map;
  $('#windyMap').remove();
  $('#map').prepend('<canvas id="windyMap" class="fill"></canvas>');
  $('#windyMap').hide();
  canvas = document.getElementById('windyMap');
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  const url: string = server;
  const getFileExtension = url.split('.').pop();
  switch (layerType.values_.title) {
    case 'Present':
      if (getFileExtension === 'zip') {
        readFiles(url);
      }
      break;
    case '3h':
      if (getFileExtension === 'zip') {
        readFiles(url);
      }
      break;
    case '6h':
      if (getFileExtension === 'zip') {
        readFiles(url);
      }
      break;
    case '9h':
      if (getFileExtension === 'zip') {
        readFiles(url);
      }
      break;
    case '12h':
      if (getFileExtension === 'zip') {
        readFiles(url);
      }
      break;
    case 'Wind':
      if (getFileExtension === 'zip') {
        readFiles(url);
      }
      break;
    default:
      break;
  }
  async function readFiles(url: any) {
    const { entries } = await unzip(url);
    // print all entries and their sizes
    for (const [name] of Object.entries(entries)) {
      /* eslint-disable no-await-in-loop */
      const data = await entries[name].json();
      windTest(data);
    }
  }
  function windTest(json: any) {
    windy = new (Windy as any)({ canvas: canvas, data: json, mapport: map });
    refreshWindy();
    const wind = document.getElementById('windyMap') as any;
    options1.map.on('pointermove', (event: any) => {
      const windiv: any = document.getElementById('wind-info') as HTMLElement;
      const windDisplay = window.getComputedStyle(wind).display;

      if (windDisplay == 'block') {
        if (windiv) {
          windiv.style.display = 'block';
          windInfo(event);
        }
      } else {
        windiv.style.display = 'none';
      }
    });
    if (wind) {
      wind.style.display = property;
    }
  }

  if (getFileExtension === 'json') {
    $.getJSON(
      // 'https://app.mapport.com/api/media/wind_data/gfs.json',
      url,
      function (json: any) {
        windy = new (Windy as any)({
          canvas: canvas,
          data: json,
          mapport: map,
        });

        refreshWindy();
        const wind = document.getElementById('windyMap') as any;
        options1.map.on('pointermove', (event: any) => {
          const windiv: any = document.getElementById(
            'wind-info'
          ) as HTMLElement;
          const windDisplay = window.getComputedStyle(wind).display;

          if (windDisplay == 'block') {
            if (windiv) {
              windiv.style.display = 'block';
              windInfo(event);
            }
          } else {
            windiv.style.display = 'none';
          }
        });
        if (wind) {
          wind.style.display = property;
        }
      }
    );
  }

  options1.map.on('moveend', () => {
    refreshWindy();
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
}

const refreshWindy = function () {
  if (!windy) {
    return;
  }
  windy.stop();
  var mapSize, extent;
  if (map == undefined) {
    mapSize = map.getSize();
    extent = map.getView().getProjection('EPSG:3857', 'EPSG:4326');
  } else {
    mapSize = map.getSize();
    extent = map.getView().calculateExtent(mapSize);
    extent = transformExtent(extent, 'EPSG:3857', 'EPSG:4326');
  }

  canvas.width = mapSize[0];
  canvas.height = mapSize[1];

  windy.start(
    [
      [0, 0],
      [canvas.width, canvas.height],
    ],
    canvas.width,
    canvas.height,
    [[extent[0], extent[1]], [extent[2], extent[3]], map.zoom]
  );
};

const windyObj = function () {
  return windy;
};

const vectorToDegrees = function (uMs: any, vMs: any) {
  var windAbs = Math.sqrt(Math.pow(uMs, 2) + Math.pow(vMs, 2));
  var windDirTrigTo = Math.atan2(uMs / windAbs, vMs / windAbs);
  var windDirTrigToDegrees = (windDirTrigTo * 180) / Math.PI;
  var windDirTrigFromDegrees = windDirTrigToDegrees + 180;
  return windDirTrigFromDegrees.toFixed(3);
};

const vectorToSpeed = function (uMs: any, vMs: any) {
  var windAbs = Math.sqrt(Math.pow(uMs, 2) + Math.pow(vMs, 2));

  windAbs = windAbs * 2.237;
  return windAbs;
};

const windInfo = function (event: any) {
  wind = map.getPixelFromCoordinate(event.coordinate);
  var coords = toLonLat(event.coordinate);
  var lat: any = coords[1];
  var lon: any = coords[0];

  lon = parseFloat(lon.toFixed(2));
  lat = parseFloat(lat.toFixed(2));
  wind.lon = lon % 360;
  wind.lat = lat % 360;
  var windyjs = windyObj();
  var gridValue = windyjs.interpolate(wind.lon, wind.lat);
  if (
    gridValue &&
    !isNaN(gridValue[0]) &&
    !isNaN(gridValue[1]) &&
    gridValue[2]
  ) {
    var vMs = gridValue[1];
    direction = vectorToDegrees(gridValue[0], vMs);
    direction = parseFloat(direction);
    speed = vectorToSpeed(gridValue[0], vMs);

    if (lon >= 0.0 && lat >= 0.0) {
      deg = lon + '° E ' + lat + '° N';
    }
    if (lon < 0.0 && lat >= 0.0) {
      deg = -1 * lon + '° W ' + lat + '° N';
    }
    if (lon >= 0.0 && lat < 0.0) {
      deg = lon + '° E ' + -1 * lat + '° S';
    }
    if (lon < 0.0 && lat < 0.0) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      deg = lon + '° W ' + -1 * lat + '° S';
    }

    $('#wind-info span').html(
      Math.round(parseFloat(direction)) +
        '°' +
        ' @ ' +
        speed.toFixed(1) +
        ' mph '
    );
  }
};
